// extracted by mini-css-extract-plugin
module.exports = {"box":"Box_box__mxLcn","header":"Box_header__XlCeD","children":"Box_children__2lVg1"};